import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainLayoutComponent } from './main-layout.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MenuModule } from '../menu/menu.module';

@NgModule({
  imports: [
    /* Core deps */
    CommonModule,
    RouterModule,
    TranslateModule,
    /* Material deps*/
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    /* App deps */
    MenuModule
  ],
  declarations: [MainLayoutComponent]
})
export class MainLayoutModule { }
